const errorStatus = {
  401: {
    message: "Unauthorized access. Please log in again.",
    action: () => {},
  },
  403: {
    message: "You do not have permission to access this resource.",
  },
  500: {
    message: "Internal server error. Please try again later.",
  },
  default: {
    message: "An unexpected error occurred. Please try again later.",
  },
};

export default errorStatus;
